/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "CustomerLimits": {
                    "fields": {
                      "odfiDepositAmountSum": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "odfiDepositAmountLimit": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "odfiDepositAmountPerTransactionMax": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "odfiDepositWindowDuration": {
                        "type": "uint32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "odfiWithdrawalAmountSum": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "odfiWithdrawalAmountLimit": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "odfiWithdrawalAmountPerTransactionMax": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 7,
                        "rule": "optional"
                      },
                      "odfiWithdrawalWindowDuration": {
                        "type": "uint32",
                        "id": 8,
                        "rule": "optional"
                      },
                      "tierUpdatedAt": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.CustomerLimits) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Information about customer transfer limits.
 * --
 *
 * SOURCE CustomerLimits @ squareup/sfs/external/models/customer_limits.proto at 11:1
 */
export const CustomerLimits = $root.lookupType('squareup.sfs.external.models.CustomerLimits');
fixType(CustomerLimits, {
  odfiDepositAmountSum: {
    required: true
  },
  odfiDepositAmountLimit: {
    required: true
  },
  odfiDepositAmountPerTransactionMax: {
    required: true
  },
  odfiDepositWindowDuration: {
    required: true
  },
  odfiWithdrawalAmountSum: {
    required: true
  },
  odfiWithdrawalAmountLimit: {
    required: true
  },
  odfiWithdrawalAmountPerTransactionMax: {
    required: true
  },
  odfiWithdrawalWindowDuration: {
    required: true
  }
});
Builder.createAndAttachToType(CustomerLimits);